export default (state: { sale: { saleData: bb.model.sale.ISaleData } }) => {
  return state.sale.saleData;
};



function getCampaignFromJsonString(jsonString:string):bb.model.sale.IHouseAdCampaign|null {
  try {
    const obj = JSON.parse(jsonString)
    const campaign:bb.model.sale.IHouseAdCampaign = {
      "id": obj.id,
      "name": obj.name,
      "description": obj.description,
      "startDate": new Date(obj.startDate),
      "endDate": new Date(obj.endDate),
      "assets": obj.assets
    }
    return campaign
  }
  catch (e:any) {
    console.error("Error parsing campaign JSON string: ", e.message)
    return null
  }
}

export function getCurrentHouseAdCampaignSelector(
  placement: keyof bb.state.ISale['houseAdCampaign']
): (state: { sale: bb.state.ISale }) => bb.model.sale.IHouseAdCampaign | null {
  return (state: { sale: bb.state.ISale }) => {

    if(process.env.REACT_APP_HARDCODED_BANNERS) {
      return getCampaignFromJsonString(process.env.REACT_APP_HARDCODED_BANNERS)
    }

    const campaign = state.sale.houseAdCampaign[placement];
    if (campaign) {
      return campaign;
    }

    return null;
  };
}
